import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
import { appreciationQuotes } from '../../../data/comprehensiveFindingsData';
import './Appreciation.css';

const Appreciation: React.FC = () => {
  return (
    <div className="tmf-appreciation">
      <div className="tmf-appreciation-quotes-grid">
        {appreciationQuotes.map((quote, index) => (
          <motion.div
            key={index}
            className="tmf-appreciation-quote-card"
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{
              duration: 0.5,
              delay: index * 0.05,
              ease: 'backOut',
            }}
          >
            <Quote className="tmf-appreciation-quote-mark" size={20} />
            <p className="tmf-appreciation-quote-text">{quote.text}</p>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default Appreciation;
